import {FORMS_CLEAR_CONFIGS, FORMS_FETCH_CONFIGS, FORMS_SET_CONFIGS} from './constants';
import {StringArray} from '../../@interfaces/types';
import {IFormConfig} from '../../@interfaces/components/Form/IFormConfig';

export const fetchFormsConfigs = () => ({type: FORMS_FETCH_CONFIGS});
export const setFormsConfigs = (configs: StringArray<IFormConfig>) => ({type: FORMS_SET_CONFIGS, payload: configs});
export const clearFormsConfigs = () => ({type: FORMS_CLEAR_CONFIGS});
